// extracted by mini-css-extract-plugin
module.exports = {"container":"v_image_text_uploads_container_container__lVLiP","item":"v_image_text_uploads_container_item__B21uR"};